class StickyAddToCart extends HTMLElement {
    constructor() {
        super();

        this.sticky = this;
        this.stickyBounds = this.findMainAddToCartButton();
        this.closeSticky = this.querySelector('[data-close-sticky-add-to-cart]');
        this.expandSticky = this.querySelector('[data-expand-sticky-add-to-cart]');
        this.openStickyButton = document.getElementById('show-sticky-product');

        this.onScrollHandler = this.onScroll.bind(this);
        this.openStickyHandler = this.openStickyModal.bind(this);
        this.closeStickyHandler = this.setCloseSticky.bind(this);
        this.expandStickyHandler = this.setExpandSticky.bind(this);
        this.documentClickHandler = this.handleDocumentClick.bind(this);
        this.closeModal = this.closeStickyModal.bind(this);
        this.isConnectedAndBound = false;
        this.visibilityFrame = null;
    }

    connectedCallback() {
        if (this.isConnectedAndBound) return;
        this.isConnectedAndBound = true;

        this.closeSticky?.addEventListener('click', this.closeStickyHandler);
        this.expandSticky?.addEventListener('click', this.expandStickyHandler);
        this.openStickyButton?.addEventListener('click', this.openStickyHandler);
        window.addEventListener('scroll', this.onScrollHandler, { passive: true });
        window.addEventListener('resize', this.onScrollHandler, { passive: true });
        document.addEventListener('click', this.documentClickHandler);

        this.updateVisibility();
    }

    disconnectedCallback() {
        if (!this.isConnectedAndBound) return;
        this.isConnectedAndBound = false;

        this.closeSticky?.removeEventListener('click', this.closeStickyHandler);
        this.expandSticky?.removeEventListener('click', this.expandStickyHandler);
        this.openStickyButton?.removeEventListener('click', this.openStickyHandler);
        window.removeEventListener('scroll', this.onScrollHandler);
        window.removeEventListener('resize', this.onScrollHandler);
        document.removeEventListener('click', this.documentClickHandler);

        if (this.visibilityFrame !== null) {
            window.cancelAnimationFrame(this.visibilityFrame);
            this.visibilityFrame = null;
        }
    }

    isRenderedMainButton(element) {
        if (!element || this.contains(element)) return false;
        if (!document.documentElement.contains(element)) return false;

        const style = window.getComputedStyle(element);
        if (style.display === 'none' || style.visibility === 'hidden') return false;

        const rect = element.getBoundingClientRect();
        return rect.width > 2 && rect.height > 2 && element.getClientRects().length > 0;
    }

    scoreMainButton(button) {
        let score = 0;
        const rect = button.getBoundingClientRect();
        const productView = this.closest('.productView');

        if (button.id === 'product-add-to-cart') score += 1000;
        if (button.matches('[data-btn-addToCart]')) score += 400;
        if (button.matches('button[name="add"], input[name="add"]')) score += 300;
        if (button.closest('.productView-details, .productView-product')) score += 250;
        if (productView && productView.contains(button)) score += 500;
        if (button.closest('quick-view, .quickView, .halo-quick-view-popup')) score -= 2000;

        score += Math.min(rect.width * rect.height, 100000) / 1000;
        return score;
    }

    findMainAddToCartButton() {
        const selectors = [
            '#product-add-to-cart',
            'form[id^="product-form-"]:not([id^="product-form-sticky-"]) button[name="add"]',
            'form[id^="product-form-"]:not([id^="product-form-sticky-"]) input[name="add"]',
            '.productView [data-btn-addToCart]:not(#product-sticky-add-to-cart)',
            '[data-combo-addtocart]'
        ];

        const seen = new Set();
        const candidates = [];

        selectors.forEach((selector) => {
            document.querySelectorAll(selector).forEach((button) => {
                if (seen.has(button)) return;
                seen.add(button);
                if (!this.isRenderedMainButton(button)) return;
                candidates.push(button);
            });
        });

        candidates.sort((a, b) => this.scoreMainButton(b) - this.scoreMainButton(a));
        return candidates[0] || null;
    }

    handleDocumentClick(event) {
        const target = event.target;
        if (!(target instanceof Element)) return;

        if (target.matches('.background-overlay') || target.closest('[data-close-sticky-mobile]')) {
            this.closeModal();
        }
    }

    openStickyModal() {
        const mobileOptions = this.querySelector('.sticky-product-mobile');
        if (!mobileOptions) return;

        document.body.classList.add('show-mobile-options');
        mobileOptions.style.bottom = `${this.clientHeight}px`;
    }

    closeStickyModal() {
        document.body.classList.remove('show-mobile-options');
    }

    updatePosition() {
        if (this.classList.contains('style-1')) {
            let bottomOffset = 0;
            const previewBar = document.getElementById('preview-bar-iframe');
            const toolbarMobile = document.querySelector('.halo-sticky-toolbar-mobile');

            if (previewBar && window.getComputedStyle(previewBar).display !== 'none') {
                bottomOffset = previewBar.offsetHeight;
            } else if (toolbarMobile && window.getComputedStyle(toolbarMobile).display !== 'none') {
                bottomOffset = toolbarMobile.offsetHeight;
            }

            this.style.setProperty('top', 'auto', 'important');
            this.style.setProperty('bottom', `${bottomOffset}px`, 'important');
            document.querySelector('.quick-order-list__total')?.style.setProperty(
                'bottom',
                `${bottomOffset + this.offsetHeight}px`
            );
            return;
        }

        if (this.classList.contains('style-2')) {
            const stickyHeader = document.querySelector('sticky-header');

            if (document.body.classList.contains('scroll-up')) {
                let topOffset = stickyHeader?.offsetHeight || 0;
                if (window.innerWidth < 551) topOffset += 20;
                this.style.top = `${topOffset}px`;
            } else if (document.body.classList.contains('scroll-down')) {
                this.style.top = window.innerWidth > 550 ? '0px' : '20px';
            }
        }
    }

    hasPassedMainButton() {
        if (!this.isRenderedMainButton(this.stickyBounds)) {
            this.stickyBounds = this.findMainAddToCartButton();
        }

        if (!this.stickyBounds) return false;

        const bounds = this.stickyBounds.getBoundingClientRect();
        return bounds.bottom <= 0;
    }

    onScroll() {
        if (this.visibilityFrame !== null) return;

        this.visibilityFrame = window.requestAnimationFrame(() => {
            this.visibilityFrame = null;
            this.updateVisibility();
        });
    }

    updateVisibility() {
        if (this.hasPassedMainButton()) {
            this.show();
            this.updatePosition();
        } else {
            this.hide();
            if (this.classList.contains('style-1')) {
                document.querySelector('.quick-order-list__total')?.style.setProperty('bottom', '0px');
            }
        }
    }

    hide() {
        this.classList.remove('mdb-after-main-cta-visible', 'show-sticky', 'full-sticky', 'animate');
        this.classList.add('mdb-sticky-hidden');
        this.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('show-mobile-options');
    }

    show() {
        this.classList.remove('hidden-sticky', 'mdb-sticky-hidden');
        this.classList.add('mdb-after-main-cta-visible', 'show-sticky', 'animate');
        this.removeAttribute('hidden');
        this.setAttribute('aria-hidden', 'false');
    }

    setCloseSticky(event) {
        event.preventDefault();

        if (this.classList.contains('full-sticky')) {
            this.classList.remove('full-sticky');
        } else {
            this.classList.add('hidden-sticky');
        }
    }

    setExpandSticky(event) {
        event.preventDefault();
        this.classList.add('full-sticky');
    }
}

if (!customElements.get('sticky-add-to-cart')) {
    customElements.define('sticky-add-to-cart', StickyAddToCart);
}


class VariantStickyAddToCart extends HTMLElement {
    constructor() {
        super();
        this.productView = this.closest('.productView') || document.querySelector('.productView');
        this.item = this.productView ? $(this.productView) : $(document);
        this.sticky = $(this).closest('.productView-stickyCart');
        this.onVariantChangeHandler = this.onVariantChange.bind(this);
        this.addEventListener('change', this.onVariantChangeHandler);
    }

    onVariantChange() {
        this.updateOptions();
        this.updateMasterId();

        if (!this.currentVariant) {
            this.updateAttribute(true);
            return;
        }

        this.updatePickupAvailability();
        this.updateMedia(200);
        this.updateURL();
        this.updateVariantInput();
        this.renderProductAjaxInfo();
        this.renderProductInfo();
        this.updateAttribute(!this.currentVariant.available);
    }

    updateOptions() {
        this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
    }

    decodeOptions() {
        this.options = this.options.map(option => {
            const parsedOption = this.decodeOption(option)
            return parsedOption
        })
    }
    
    decodeOption(option) {
      if (option) {
          return option.split('Special_Double_Quote').join('"').split('Special_Slash').join('/')
        } else {
          return null
        }
    }

    encodeOption(option) {
        if (option) {
          return option.split('"').join('Special_Double_Quote').split('/').join('Special_Slash')
        } else {
          return null
        }
    }

    updateMasterId() {
        this.decodeOptions();
        const selectedVariantId = Number.parseInt(this.options?.[0], 10);
        this.currentVariant = this.getVariantData().find((variant) => Number(variant.id) === selectedVariantId);
    }

    updateMedia(time) {
        if (!this.currentVariant || !this.currentVariant?.featured_media) return;

        const itemImage = this.item.find('.sticky-image');
        const image = this.currentVariant.featured_image;
        if (!itemImage.length || !image) return;

        itemImage.find('img').attr({
            'src': image.src,
            'srcset': image.src,
            'alt': image.alt
        });

        const newMedia = document.querySelectorAll(
            `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
        );

        if (!newMedia.length) return;
        window.setTimeout(() => {
            $(newMedia).trigger('click');
        }, time);
    }

    updateURL() {
        if (!this.currentVariant) return;

        const url = new URL(window.location.href);
        url.searchParams.set('variant', String(this.currentVariant.id));
        window.history.replaceState({}, '', `${url.pathname}${url.search}${url.hash}`);
    }

    updateVariantInput() {
        const productForms = document.querySelectorAll(`#product-form-${this.dataset.product}, #product-form-installment-${this.dataset.product}, #product-form-sticky-${this.dataset.product}`);
  
        if (!this.currentVariant) return;

        productForms.forEach((productForm) => {
            const input = productForm.querySelector('input[name="id"]');
            if (!input) return;

            input.value = this.currentVariant.id;
            input.dispatchEvent(new Event('change', { bubbles: true }));
        });
    }

    updatePickupAvailability() {
        const pickUpAvailability = document.querySelector('pickup-availability');
        if (!pickUpAvailability) return;

        if (this.currentVariant?.available) {
            pickUpAvailability.fetchAvailability(this.currentVariant.id);
        } else {
            pickUpAvailability.removeAttribute('available');
            pickUpAvailability.innerHTML = '';
        }
    }

    renderProductAjaxInfo() {
        if (!this.currentVariant || !this.dataset.url || !this.dataset.section) return;

        fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
            .then((response) => {
                if (!response.ok) throw new Error(`HTTP ${response.status}`);
                return response.text();
            })
            .then((responseText) => {
                const id = `product-price-${this.dataset.product}`;
                const html = new DOMParser().parseFromString(responseText, 'text/html');
                const destination = document.getElementById(id);
                const source = html.getElementById(id);

                if (source && destination) {
                    destination.innerHTML = source.innerHTML;
                }

                if (this.checkNeedToConvertCurrency() && window.Currency?.convertAll) {
                    const currencyCode = document.getElementById('currencies')?.querySelector('.active')?.getAttribute('data-currency');
                    if (currencyCode) {
                        Currency.convertAll(window.shop_currency, currencyCode, 'span.money', 'money_format');
                    }
                }

                destination?.classList.remove('visibility-hidden');
            })
            .catch((error) => {
                console.warn('[Sticky ATC] Price refresh failed:', error);
                document.getElementById(`product-price-${this.dataset.product}`)?.classList.remove('visibility-hidden');
            });
    }

    renderProductInfo() {
        if (!this.currentVariant) return;

        const variantData = this.getVariantData();
        const availableVariants = variantData.filter((variant) => variant.available);
        const selectedOptions = this.currentVariant.options || [
            this.currentVariant.option1,
            this.currentVariant.option2,
            this.currentVariant.option3
        ].filter((option) => option != null);

        const optionGroups = this.item.find('.product-form__input:not(.mobile), .product-form__input.mobile');

        optionGroups.each((index, element) => {
            const $group = $(element);
            const position = Number.parseInt($group.data('option-index'), 10);
            if (!Number.isInteger(position) || position < 0 || position >= selectedOptions.length) return;

            const selectedValue = selectedOptions[position];
            const $header = $group.find('[data-header-option]');
            const $select = $group.find('.select__select');
            const $radios = $group.find('.product-form__radio');

            $header.text(selectedValue || '');

            if ($select.length) {
                $select.val(selectedValue);
                $select.find('option').each((optionIndex, optionElement) => {
                    const optionValue = this.decodeOption(optionElement.value);
                    const isSelected = optionValue === selectedValue;
                    const isAvailable = availableVariants.some((variant) => {
                        return variant.options.every((value, variantOptionIndex) => {
                            return variantOptionIndex === position
                                ? value === optionValue
                                : value === selectedOptions[variantOptionIndex];
                        });
                    });

                    $(optionElement)
                        .prop('selected', isSelected)
                        .prop('disabled', !isAvailable && !isSelected);
                });
            }

            if ($radios.length) {
                $radios.each((radioIndex, radioElement) => {
                    const optionValue = this.decodeOption(radioElement.value);
                    const isSelected = optionValue === selectedValue;
                    const isAvailable = availableVariants.some((variant) => {
                        return variant.options.every((value, variantOptionIndex) => {
                            return variantOptionIndex === position
                                ? value === optionValue
                                : value === selectedOptions[variantOptionIndex];
                        });
                    });
                    const $radio = $(radioElement);
                    const $label = $radio.next('label');

                    $radio.prop('checked', isSelected);
                    $label.toggleClass('available', isAvailable).toggleClass('soldout', !isAvailable);
                });

            }
        });

        this.item.find('[data-sku] .productView-info-value').text(this.currentVariant.sku || '');
        this.item.find('[data-barcode] .productView-info-value').text(this.currentVariant.barcode || '');

        const inventory = this.currentVariant.inventory_management;
        if (inventory == null) return;

        const inventoryMap = window[`product_inven_array_${this.dataset.product}`];
        if (!inventoryMap) return;

        const inventoryQuantity = Number.parseInt(inventoryMap[this.currentVariant.id], 10);
        const $quantityInputs = this.item.find('input[name="quantity"]');
        const $stickyButton = this.sticky.find('button#product-sticky-add-to-cart');

        if (Number.isFinite(inventoryQuantity)) {
            if ($quantityInputs.length) {
                $quantityInputs.attr('data-inventory-quantity', inventoryQuantity);
            } else {
                $stickyButton.attr('data-inventory-quantity', inventoryQuantity);
            }
        }

        const $inventoryInfo = this.item.find('[data-inventory] .productView-info-value');
        if ($inventoryInfo.length && window.inventory_text) {
            $inventoryInfo.text(inventoryQuantity > 0 ? window.inventory_text.inStock : window.inventory_text.outOfStock);
        }

        const $hotStock = this.item.find('.productView-hotStock');
        if ($hotStock.length) {
            const maxStock = Number.parseInt($hotStock.data('hot-stock'), 10);
            if (Number.isFinite(inventoryQuantity) && inventoryQuantity > 0 && inventoryQuantity <= maxStock && window.inventory_text?.hotStock) {
                $hotStock.text(window.inventory_text.hotStock.replace('[inventory]', inventoryQuantity)).show();
            } else {
                $hotStock.hide();
            }
        }
    }

    updateAttribute(disable = true) {
        const addButton = document.getElementById(`product-form-${this.dataset.product}`)?.querySelector('[name="add"]');
        const stickyButton = document.getElementById(`product-form-sticky-${this.dataset.product}`)?.querySelector('[name="add"]');
        const $stickyRoot = this.sticky.length ? this.sticky : $('[data-sticky-add-to-cart]').first();
        const $quantityInputs = $stickyRoot.find('input[name="quantity"], .quantity__input');
        const $submitButtons = $stickyRoot.find('.product-form__submit');
        const $notifyMe = this.item.find('.productView-notifyMe');
        const soldOutText = window.variantStrings?.soldOut || 'Sold out';

        if (disable || !this.currentVariant) {
            this.item.removeClass('isChecked');
            $quantityInputs.attr('data-price', this.currentVariant?.price || '').prop('disabled', true);

            if (addButton) {
                addButton.disabled = true;
                addButton.textContent = soldOutText;
            }

            if (stickyButton) {
                stickyButton.disabled = true;
                stickyButton.textContent = soldOutText;
                stickyButton.classList.add('sold-out');
            }

            if ($notifyMe.length && this.currentVariant) {
                $notifyMe.find('.halo-notify-product-variant').val(this.currentVariant.title || '');
                $notifyMe.find('.notifyMe-text').empty();
                $notifyMe.slideDown('slow');
            }
            return;
        }

        const price = Number(this.currentVariant.price) || 0;
        const quantity = Math.max(1, Number.parseInt($quantityInputs.first().val(), 10) || 1);
        let maxValue = Number.parseInt($quantityInputs.first().attr('data-inventory-quantity'), 10);

        if (!Number.isFinite(maxValue)) {
            maxValue = Number.parseInt($submitButtons.first().attr('data-inventory-quantity'), 10);
        }
        if (!Number.isFinite(maxValue) && Number.isFinite(Number(this.currentVariant.inventory_quantity))) {
            maxValue = Number(this.currentVariant.inventory_quantity);
        }

        const subtotalEnabled = Boolean(window.subtotal?.show);
        const isPreOrder = Boolean(
            this.currentVariant.available &&
            this.currentVariant.inventory_management === 'shopify' &&
            Number.isFinite(maxValue) &&
            maxValue <= 0
        );

        const formattedPrice = this.formatMoney(subtotalEnabled ? quantity * price : price);
        let mainButtonText = isPreOrder
            ? (window.variantStrings?.preOrder || window.variantStrings?.addToCart || 'Add to cart')
            : (window.variantStrings?.addToCart || 'Add to cart');

        if (subtotalEnabled && window.subtotal?.style === '2' && !isPreOrder && window.subtotal?.text) {
            mainButtonText = window.subtotal.text.replace('[value]', formattedPrice);
        }

        this.item.addClass('isChecked');
        $quantityInputs.attr('data-price', price).prop('disabled', false);

        if (addButton) {
            addButton.disabled = false;
            addButton.textContent = mainButtonText;
        }

        if (stickyButton) {
            stickyButton.disabled = false;
            stickyButton.classList.remove('sold-out');
            stickyButton.textContent = isPreOrder
                ? (window.variantStrings?.preOrder || stickyButton.dataset.labelAvailable || mainButtonText)
                : (stickyButton.dataset.labelAvailable || mainButtonText);
        }

        $stickyRoot.find('.money-subtotal').each((index, element) => {
            element.textContent = formattedPrice;
        });

        if (subtotalEnabled && window.subtotal?.style === '1') {
            const productSubtotal = document.querySelector('.productView-subtotal .money, .productView-subtotal .money-subtotal');
            if (productSubtotal) productSubtotal.textContent = formattedPrice;
        }

        const compareAtPrice = Number(this.currentVariant.compare_at_price) || 0;
        const formattedComparePrice = compareAtPrice > price
            ? this.formatMoney((subtotalEnabled ? quantity : 1) * compareAtPrice)
            : '';

        $stickyRoot.find('.sticky-price').each((index, priceContainer) => {
            const $priceContainer = $(priceContainer);
            const $subtotal = $priceContainer.find('.money-subtotal').first();
            let $compare = $priceContainer.find('.money-compare-price').first();

            $priceContainer.find('.money-compare-price').slice(1).remove();

            if (formattedComparePrice) {
                $priceContainer.addClass('has-compare-price');
                if (!$compare.length) {
                    $compare = $('<s class="money-compare-price"></s>');
                    if ($subtotal.length) {
                        $compare.insertBefore($subtotal);
                    } else {
                        $priceContainer.prepend($compare);
                    }
                }
                $compare.attr('data-compare-price', compareAtPrice).text(formattedComparePrice);
            } else {
                $priceContainer.removeClass('has-compare-price');
                $compare.remove();
            }
        });

        if ($notifyMe.length) $notifyMe.slideUp('slow');
    }

    formatMoney(cents) {
        if (!window.Shopify?.formatMoney) return String(cents);

        let formatted = Shopify.formatMoney(cents, window.money_format);
        if (typeof window.extractContent === 'function') {
            formatted = window.extractContent(formatted);
        } else if (typeof extractContent === 'function') {
            formatted = extractContent(formatted);
        }

        const temporaryMoney = document.createElement('span');
        temporaryMoney.className = window.currencyFormatted ? 'money' : 'money-subtotal';
        temporaryMoney.innerHTML = formatted;
        document.body.appendChild(temporaryMoney);

        if (this.checkNeedToConvertCurrency() && window.Currency?.convertAll) {
            const currencyCode = document.getElementById('currencies')?.querySelector('.active')?.getAttribute('data-currency');
            if (currencyCode) {
                Currency.convertAll(window.shop_currency, currencyCode, 'span.money', 'money_format');
            }
        }

        const result = temporaryMoney.textContent.trim();
        temporaryMoney.remove();
        return result;
    }

    getVariantData() {
        if (this.variantData) return this.variantData;

        const dataElement = this.querySelector('[type="application/json"]');
        if (!dataElement) return [];

        try {
            this.variantData = JSON.parse(dataElement.textContent);
        } catch (error) {
            console.error('[Sticky ATC] Invalid variant JSON:', error);
            this.variantData = [];
        }

        return this.variantData;
    }

    checkNeedToConvertCurrency() {
        const currencyItems = $('.dropdown-item[data-currency]');
        if (!currencyItems.length || !window.Currency) return false;

        const shopCurrencyValue = window.shopCurrency || window.shop_currency;
        return Boolean(
            (window.show_multiple_currencies && Currency.currentCurrency !== shopCurrencyValue) ||
            window.show_auto_currency
        );
    }
}

if (!customElements.get('variant-sticky-selects')) {
    customElements.define('variant-sticky-selects', VariantStickyAddToCart);
}

class VariantStickyRadios extends VariantStickyAddToCart {
    constructor() {
        super();        
    }

    connectedCallback() {
        this.updateMediaTimeout = undefined
    }

    onVariantChange() {
        this.updateOptions();
        this.updateMasterId();

        if (!this.currentVariant) {
            this.updateAttribute(true);
            return;
        }

        this.updatePickupAvailability();
        this.updateMedia(10);
        this.updateURL();
        this.updateSelectVariant();
        this.updateVariantInput();
        this.renderProductAjaxInfo();
        this.renderProductInfo();
        this.updateAttribute(!this.currentVariant.available);
    }   

    updateOptions() {
        const fieldsets = Array.from(this.querySelectorAll('fieldset'));
        this.options = fieldsets.map((fieldset) => {
            const checkedRadio = Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked);
            return checkedRadio ? checkedRadio.value : null;
        });
    }

    decodeOptions() {
        this.options = this.options.map(option => {
            const parsedOption = this.decodeOption(option)
            return parsedOption
        })
    }
  
    decodeOption(option) {
      if (option) {
          return option.split('Special_Double_Quote').join('"').split('Special_Slash').join('/')
        } else {
          return null
        }
    }

    encodeOption(option) {
        if (option) {
          return option.split('"').join('Special_Double_Quote').split('/').join('Special_Slash')
        } else {
          return null
        }
    }

    updateSelectVariant() {
        if (!this.currentVariant) return;
        const stickyRoot = this.closest('.productView-stickyCart');
        const selectElement = stickyRoot?.querySelector('variant-sticky-selects select');
        if (selectElement) selectElement.value = String(this.currentVariant.id);
    }

    updateMasterId() {
        this.decodeOptions()
        this.currentVariant = this.getVariantData().find((variant) => {
            return !variant.options.map((option, index) => {
                return this.options[index] === option;
            }).includes(false);
        });
    }

    updateMedia(time) {
        if (!this.currentVariant || !this.currentVariant?.featured_media) return;

        const itemImage = this.item.find('.sticky-image');
        const image = this.currentVariant.featured_image;
        if (!itemImage.length || !image) return;

        itemImage.find('img').attr({
            'src': image.src,
            'srcset': image.src,
            'alt': image.alt
        });

        const newMedia = document.querySelectorAll(
            `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
        );

        if (!newMedia.length) return;
        
        clearTimeout(this.updateMediaTimeout);
        this.updateMediaTimeout = setTimeout(() => {
            $(newMedia).trigger('click');
        }, time);
    }

    openStickyModal() {
        document.body.classList.add('show-mobile-options');
    }

    closeStickyModal() {
        document.body.classList.remove('show-mobile-options');
    }
}

if (!customElements.get('variant-sticky-radios')) {
    customElements.define('variant-sticky-radios', VariantStickyRadios);
}

function parseDoubleQuote(option, isDecoding = true) {
    if (!option) return option;
    
    if (isDecoding) {
      return option.split('"').join('spc_dbl_qte')
    } else {
      return option.split('spc_dbl_qte').join('"')
    }
}